import CampaignService from "@/services/CampaignService"

export const fetchCampaign = async ({ commit }, data) => {
  const campaign = await CampaignService.getCampaign(data)
  commit("setCampaign", campaign)

  return campaign
}

export const fetchCampaigns = async ({ commit }, data) => {
  const targets = await CampaignService.getCampaigntList(data)
  commit("setCampaigns", targets)

  return targets
}

export const updateCampaign = async ({ commit }, data) => {
  const campaign = await CampaignService.updateCampaign(data)
  commit("setCampaign", campaign)

  return campaign
}

export const fetchTargets = async ({ commit }, id) => {
  const targets = await CampaignService.getTargets(id)
  commit("setTargets", targets)

  return targets
}

export const fetchTargetDetail = async ({ commit }, { id, path, type }) => {
  const targetDetail = await CampaignService.getTargetDetail(id, path, type)

  commit("setTargetDetail", targetDetail)

  return targetDetail
}

export const fetchRuleChains = async ({ commit }, id) => {
  const ruleChains = await CampaignService.getRuleChains(id)
  commit("setRuleChains", ruleChains)

  return ruleChains
}
